/**
 * Telefone em formato de gente.
 *
 * O painel mostrava "5511922223333" como nome do contato quando o WhatsApp não
 * mandava o nome do perfil. Sequência de treze dígitos não se lê, não se
 * memoriza e não se dita ao telefone — e é a primeira coisa que a recepção vê
 * na lista de conversas.
 */
export function formatarTelefone(bruto: string): string {
  const d = bruto.replace(/\D/g, "");

  // 55 + DDD + 9 dígitos (celular) ou 8 (fixo antigo)
  const br = d.startsWith("55") ? d.slice(2) : d;
  if (br.length === 11) return `(${br.slice(0, 2)}) ${br.slice(2, 7)}-${br.slice(7)}`;
  if (br.length === 10) return `(${br.slice(0, 2)}) ${br.slice(2, 6)}-${br.slice(6)}`;

  // Número de fora do padrão: devolve como veio, com o + na frente para pelo
  // menos parecer telefone.
  return bruto.startsWith("+") ? bruto : `+${d}`;
}

/** O que mostrar como nome: o do perfil, ou o telefone formatado. */
export function comoChamar(nome: string | null | undefined, telefone: string): string {
  return nome?.trim() || formatarTelefone(telefone);
}
